import { createApp }  from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant' 
import 'vant/lib/index.css'
import * as echarts from 'echarts'
 const app=createApp(App)
 app.config.globalProperties.$echarts = echarts
app.use(Vant).use(store).use(router).mount('#app')

